import { useContext, useState, FC, ReactNode } from 'react';

import Button from '../UI/Button/Button';
import { AvatarIcon } from '../AvatarIcon/AvatarIcon';
import images from '../../assets/images/profile-avatars';
import { useChangeImageMutation } from '../../services/api';
import { AvatarContext } from '../../context/userData-context';
import CloseIcon from '../../assets/images/close-icon.svg?react';

import './AvatarPicker.css';
import { RootState, useAppSelector } from '../../services/store';

interface AvatarPickerProps {
  onClose: () => void;
  setAvatarSrc: (src: string) => void;
  onCancel: () => void;
  userId?: string;
}

export const AvatarPicker: FC<AvatarPickerProps> = ({ onClose, setAvatarSrc, onCancel, userId = undefined }) => {
  const avatarContext = useContext(AvatarContext);
  const [selectedAvatar, setSelectedAvatar] = useState<ReactNode>(avatarContext.avatar);
  // cannot be null here.
  const stateUserId = useAppSelector((state: RootState) => state.user.userId) as string;
  const currentUserId: string = userId ? userId : stateUserId;

  const [changeImage] = useChangeImageMutation();
  const onSave = async () => {
    try {
      setAvatarSrc(selectedAvatar as string);
      await changeImage({
        id: currentUserId,
        image: selectedAvatar as string
      });
    } catch (err) {
      console.log(err);
    }
  };
  const saveAndClose = () => {
    onSave();
    onClose();
  };

  return (
    <div className="avatar-picker-container">
      <div className="avatar-picker-header">
        <span className="avatar-picker-header-title">Select user avatar</span>
        <CloseIcon style={{ cursor: 'pointer' }} onClick={onCancel} />
      </div>
      <div className="avatar-picker-content" style={{ height: '70%' }}>
        <div className="avatars-picker-box">
          {images.map((img, index) => {
            return (
              <AvatarIcon
                img={img}
                key={index}
                isSelected={selectedAvatar === img}
                onClick={() => setSelectedAvatar(img)}
              />
            );
          })}
        </div>
      </div>
      <div className="avatar-picker-bottom-section">
        <Button inverseBlack onClick={saveAndClose}>
          Save
        </Button>
      </div>
    </div>
  );
};
